/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import {PaintingSlide} from './PaintingSlide.jsx';

import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import { useLocation } from "react-router";
import { slideData } from './../data';
import { StageScriptOverlay } from './StageScriptOverlay.jsx';
import { CreditsOverlay } from './CreditsOverlay.jsx';


export const Slides = () => {


  const [sw,setSw] = useState();
  const [curIndex,setCurIndex] = useState(0);
  const [curInfo,setCurInfo] = useState('');
  const [showCredits,setShowCredits] = useState(false);

  const swiperRef = useRef();
  let loc = useLocation();

  const getInitialSlide = () => {
    var path = loc.pathname.replace('/','');
    var hash = loc.hash.replace('#','');
    if (path) return path
    if (hash) return hash
    return 1
  }

  // const playMusic = useCallback((src) => {

  //   console.log(howl)
  //   if (howl){
  //     howl.stop();
  //     howl.unload();
  //   }


  //   let sound = new Howl({
  //     src: [src],
  //     html5: true
  //   })

  //   sound.play();
  //   setHowl(sound);

  //   console.log('playMusc:::',src )
  // },[howl]);


  useEffect(() => {
    
    if (sw){
      sw.destroy(true,true);
    }

    let initSlide = Number(getInitialSlide())-1
    let swiper = new Swiper(swiperRef.current,{
      modules: [Navigation, Pagination],
      loop: true,
      //autoHeight:true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      initialSlide: initSlide
    });

    swiper.on('beforeSlideChangeStart',()=>{
      console.log('Start');
    });

    swiper.on('slideChange',(swref)=>{
      setCurIndex( swref.realIndex );
    });
    setSw(swiper);
  }, [])


  useEffect(  ()=>{
  },[sw])

  return (
    <div className="swiper" ref={swiperRef}>

      <header className="app-header w-full">
        <div class="flex-1">
          <div className="app-title pt-2">ANDERS SUNNA</div>
          <div className="app-subtitle"><i>Illegal Spirits of Sápmi</i> (2022)</div>
        </div>
        <div>
        <button className="btn colored" onClick={ e=>setShowCredits(true) }>
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.218 2.782C14.424 0.988 12.038 0 9.5 0C6.962 0 4.577 0.988 2.782 2.782C0.987 4.576 0 6.962 0 9.499C0 12.036 0.988 14.422 2.782 16.217C4.576 18.012 6.962 18.999 9.5 18.999C12.038 18.999 14.423 18.011 16.218 16.217C18.013 14.423 19 12.037 19 9.499C19 6.961 18.012 4.576 16.218 2.782ZM9.5 18C4.813 18 1 14.187 1 9.5C1 4.813 4.813 1 9.5 1C14.187 1 18 4.813 18 9.5C18 14.187 14.187 18 9.5 18ZM10.575 4.548C10.591 5.028 10.239 5.412 9.679 5.412C9.183 5.412 8.831 5.028 8.831 4.548C8.831 4.052 9.199 3.668 9.711 3.668C10.239 3.668 10.575 4.052 10.575 4.548ZM9.007 14.469V6.725H10.415V14.469H9.007Z" fill="#fff"/>
            </svg>
          </button>   
        </div>
      </header>

      <div className="swiper-wrapper">
      { slideData.map( (el)=><PaintingSlide 
          key={el.title} 
          data={el} 
          onInfo={ (opt)=>{ setCurInfo( opt ) }} 
          slideIndex={ curIndex }
        />          
      )}
      </div>
      <div className="nav-footer">
        
       <div className="swiper-pagination"></div>


        {/* <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div> */}
      </div>
      {curInfo && <StageScriptOverlay data={ curInfo } onClose={ e=>setCurInfo('') }/>}
      {showCredits && <CreditsOverlay data={ curInfo } onClose={ e=>setShowCredits(false) }/>}
    </div>

  )

}



